import React, { Fragment, useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { LeadForm } from './common'
import { breadcrumbsBy } from '../../../services/locations'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faKey, faEye, faTrash, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from "react-helmet-async";

import { Modal } from '../../UI'

const Edit = ({ match, history }) => {

    const { data, leadServices, location } = useContext(AppContext)
    const { app, isReady } = data
    const { user } = app

    const [ loading, setLoading ] = useState(false)
    const [ deleting, setDeleting ] = useState(false)
    const [ lead, setLead ] = useState(null)

    const id = parseInt(match.params.id)

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogOptions, setDialogOptions ] = useState({})

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel', 'close'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['delete'].includes(button)){
                    setShowDialog(false)
                    resolve()
                }
            }
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(true)
        })
    }

    const loadLead = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            leadServices.view(id).then(res => {
                setLead(res.lead)
                setLoading(false)
                resolve()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    const deleteLead = () => {
        return new Promise((resolve, reject) => {
            setDeleting(true)
            leadServices.delete(id).then(res => {
                setDeleting(false)
                history.push("/account/leads")
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        if(isReady) loadLead()
    }, [ isReady ])

    const title = lead ? ('Edit lead #' + lead.id) : "Edit a lead"

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/leads', title: 'Leads & sales'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>
                        
                        <div className="d-flex justify-content-between">
                            <h1 className="mt-0">{title}</h1>
                            <div className="ms-3">
                                <Link tag="a" to={'/account/leads'} className="btn btn-outline-secondary">
                                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                                    Back to Leads
                                </Link>
                                {lead &&
                                    <Fragment>
                                        <Link tag="a" to={'/account/leads/view/' + lead.id} className="btn btn-outline-primary ms-2">
                                            <FontAwesomeIcon icon={faEye} className="me-2" />
                                            View
                                        </Link>
                                        <button className="btn btn-outline-danger ms-2" onClick={() => {
                                            modalDialog({
                                                title: 'Confirm',
                                                description: 'Are you sure want to delete the lead #' + lead.id + '?',
                                                buttons: ['cancel', 'delete'],
                                                size: 'md'
                                            }).then(() => deleteLead()).catch(res => {})
                                        }}>
                                            {!deleting && <FontAwesomeIcon icon={faTrash} className="me-2" />}
                                            {deleting && <FontAwesomeIcon icon={faSpinner} spin className="me-2" />}
                                            Delete
                                        </button>
                                    </Fragment>
                                }
                            </div>
                        </div>

                        {lead && <LeadForm
                            initLead={lead}
                            onUpdated={res => history.push('/account/leads/view/' + lead.id)}
                        />}
                    </div>
                </main>
            </div>
            <Modal {...dialogOptions} show={showDialog} />
            <Footer />
        </Fragment>
    )
}

export default Edit
